import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/main/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/leaveMessage",
    name: "leaveMessage",
    component: () => import("../views/leaveMessage/index.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/collectionFrom",
    name: "collectionFrom",
    component: () => import("../views/collectionFrom/index.vue"),
    meta: {
      keepAlive: false,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
